import { PathCode, PathName } from 'src/app/shared/enum/path-type.enum';

export enum Product {
  HC = 'HC',
  HP = 'HP',
  HS = 'HS',
  HT = 'HT',
  HL = 'HL',
  HG = 'HG',
  HR = 'HR',
  HE = 'HE',
  HA = 'HA',
  BS = 'BS',
}

export interface ProductInfo {
  code: Product;
  label: string;
  logo: string;
  name: string;
  codes: PathCode[];
}

const productInfoMap: ProductInfo[] = [
  // No need logo for this product
  {
    code: Product.HC,
    label: 'Confort',
    logo: '',
    name: PathName.CONFORT,
    codes: [PathCode.CON, PathCode.CON2],
  },
  {
    code: Product.HC,
    label: 'Confort+',
    logo: '',
    name: PathName.CONFORT_PLUS,
    codes: [PathCode.CONP, PathCode.CONP2],
  },
  {
    code: Product.HE,
    label: 'Etudiant',
    logo: '',
    name: PathName.ETUDIANT,
    codes: [PathCode.ETU],
  },
  {
    code: Product.HS,
    label: 'Solidaire',
    logo: '',
    name: PathName.SOLIDAIRE,
    codes: [PathCode.SOL, PathCode.SOL2],
  },
  {
    code: Product.BS,
    label: 'Solidaire',
    logo: '',
    name: PathName.SOLIDAIRE,
    codes: [PathCode.BSOL],
  },
  {
    code: Product.HP,
    label: 'Paris',
    logo: 'assets/common/Paris.svg',
    name: PathName.PARIS,
    codes: [PathCode.PAR2, PathCode.PAR],
  },
  {
    code: Product.HT,
    label: 'Tourcoing',
    logo: 'assets/common/Tourcoing.svg',
    name: PathName.TOURCOING,
    codes: [PathCode.TOU, PathCode.TOU2],
  },
  {
    code: Product.HL,
    label: 'Lille',
    logo: 'assets/common/LilleHellemmesLomme.svg',
    name: PathName.LILLE,
    codes: [PathCode.LIL, PathCode.LIL2],
  },
  {
    code: Product.HG,
    label: 'Grenoble',
    logo: 'assets/common/GrenobleAlpesMetropole.svg',
    name: PathName.GRENOBLE,
    codes: [PathCode.GRE],
  },
  {
    code: Product.HR,
    label: 'Creteil',
    logo: 'assets/common/Creteil.svg',
    name: PathName.CRETEIL,
    codes: [PathCode.CRE],
  },
  {
    code: Product.HA,
    label: 'Marseille',
    logo: 'assets/common/Marseille.svg',
    name: PathName.MARSEILLE,
    codes: [PathCode.MAR],
  },
];

export const getProductInfo = (productCode: string): ProductInfo | undefined => {
  return productInfoMap.find((productInfo) => productInfo.code === productCode);
};

export function getImgPlafond(productCode: string, brand: string): string {
  return 'assets/common/{0}/popup-info/plafonds{1}.png'
    .replace('{0}', brand)
    .replace('{1}', productCode);
}

export function getProductFromCode(code: string): ProductInfo | undefined {
  const productInfo = productInfoMap.find((product) => product.codes.includes(code as PathCode));
  return productInfo ? productInfo : undefined;
}
